// frontend/src/utils/validation.js

/**
 * Validates a Canadian Business Number (BN9) using the CRA Modulus 10 algorithm.
 * Weighting Factor: 1 2 1 2 1 2 1 2 1
 * @param {string} bn - The 9-digit Business Number string
 * @returns {boolean} - True if valid, False if invalid
 */
export const validateBN9 = (bn) => {
  // 1. Basic Format Check
  if (!bn || typeof bn !== 'string') return false;
  const cleanBN = bn.replace(/\D/g, ''); // Remove non-digits
  if (cleanBN.length !== 9) return false;

  // 2. Modulus 10 Logic (CRA Standard)
  // Weights for each position: 1 2 1 2 1 2 1 2 1
  // We multiply each digit by its weight. If result > 9, subtract 9.
  // Sum results. If sum % 10 === 0, it is valid.
  
  const weights = [1, 2, 1, 2, 1, 2, 1, 2, 1];
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    let digit = parseInt(cleanBN[i], 10);
    let product = digit * weights[i];

    // Digital Root logic for CRA check
    if (product > 9) {
      product = product - 9; 
    }
    
    sum += product;
  }

  // Valid if sum is divisible by 10
  return sum % 10 === 0;
};

/**
 * Strict Phone Number Validator (North American Numbering Plan)
 * Rejects "555" fake numbers in production mode if needed.
 * @param {string} phone 
 * @returns {boolean}
 */
export const validatePhone = (phone) => {
  const cleanPhone = phone.replace(/\D/g, '');
  // Must be 10 or 11 digits (if leading 1)
  return /^(1?)\d{10}$/.test(cleanPhone);
};

/**
 * Sanitizes input to prevent basic XSS before sending to state
 * @param {string} text 
 * @returns {string}
 */
export const sanitizeInput = (text) => {
  if (!text) return '';
  return text.replace(/[<>]/g, ''); // Strip basic HTML tags
};